// @flow

import React from 'react';
import { connect } from 'react-redux';

import { Button } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

import { appStoreLink } from 'src/modules/app-install-banner';
import { currentDevice } from 'src/modules/chalice-user-agent/device-detect';

type Props = {
  analytics: string,
  text?: string,
  color: string,
  storePath: string,
  locale: Locale,
  className: string,
  onClick?: Function,
  campaignSuffix?: string
};

const mapStateToProps = ({ location }) => ({
  locale: location.locale
});

const AppInstallBannerButton = ({
  analytics,
  color,
  text,
  locale,
  className,
  storePath,
  onClick,
  campaignSuffix
}: Props) => {
  const appStoreFn = appStoreLink(currentDevice());

  return (
    <NavLink
      analytics={analytics}
      onClick={onClick}
      color={color}
      component={Button}
      className={className}
      location={appStoreFn({ locale, path: storePath, campaignSuffix })}
    >
      {text || 'Continue in app'}
    </NavLink>
  );
};

export default connect(mapStateToProps)(AppInstallBannerButton);
